import { DEPOSIT } from "../../actions/type";

export default function deposit(state = {}, action) {
    switch (action.type) {
        case DEPOSIT:
            return action.payload;
        default:
            return state
    }
}